import { css } from 'styled-components';
export const formTextElementStyles = css `
  ${({ $isDisabled, $paddingRight, characterCounter, theme: { colors, font, space }, }) => {
    return `
    flex: 1;
    min-height: 44px;
    display: inline-block;
    color: ${colors['slate-5']};
    font-size: ${font.body.md.size};
    padding: ${space.xs};
    padding-right: ${(characterCounter === null || characterCounter === void 0 ? void 0 : characterCounter.show) ? `${$paddingRight}px` : space.xs};
    box-sizing: border-box;

    border: none;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;

    &::placeholder {
      color: ${colors['slate-4']};
      font-style: italic;
    }

    &:focus {
      outline: none;
    }

    ${$isDisabled ? `color: ${colors['periwinkle-500']};` : ''}
    ${$isDisabled ? 'cursor: not-allowed;' : ''}
  `;
}}
`;
export const formTextBackgroundStyles = css `
  ${({ $isHovered, $isDisabled, theme: { colors } }) => `
    background: ${colors['light-gray']};
    ${$isHovered ? `background: ${colors['page-gray']};` : ''}
    ${$isDisabled ? `background: ${colors['periwinkle-100']};` : ''}
    ${$isDisabled ? `color: ${colors['periwinkle-500']};` : ''}

    * {
      ${$isDisabled ? `color: ${colors['periwinkle-500']};` : ''}
    }
  `}
`;
export const formTextBorderStyles = css `
  ${({ $isFocused, $hasError, $isDisabled, theme: { colors } }) => `
    position: absolute;
    bottom: -1px;
    left: 0;
    right: 0;
    height: 1px;
    background: ${colors['slate-3']};

    ${$isDisabled ? `background: ${colors['periwinkle-500']};` : ''}

    ${$hasError ? `background: ${colors.error};` : ''}

    ${$isFocused ? 'height: 3px;' : ''}
    ${$isFocused ? 'bottom: -3px;' : ''}
    ${$isFocused ? `background: ${colors.bluesuedeshoes};` : ''}

    transition: height 100ms ease-in-out, bottom 100ms ease-in-out;
  `}
`;
//# sourceMappingURL=styles.js.map